<template>
  <div
    class="container min-body-height"
    :class="UI.isMobile ? '' : 'padding-top'"
  >
    <div
      class="flex margin-top-lg align-center "
      v-if="playerInfo.user_id"
      :class="UI.isMobile ? 'flex-direction justify-center' : ''"
    >
      <div
        :style="`width: ${UI.isMobile ? '30vw' : '10vw'}`"
        class="text-center"
      >
        <img :src="playerInfo.user_info.avatar" style="width: 80%" />
      </div>
      <div style="margin-bottom:3vw" :class="UI.isMobile ? '' : 'margin-left'">
        <h1 :class="UI.isMobile ? 'text-center' : ''">
          {{ playerInfo.user_info.name }}
        </h1>

        <div
          class="flex flex-wrap margin-top"
          :class="UI.isMobile ? 'text-center flex-direction' : ''"
        >
          <div>性别: {{ playerInfo.user_info.sex == 0 ? '男' : '女' }}</div>
          <div :class="UI.isMobile ? 'margin-top-xs' : 'margin-left'">
            出生年: {{ playerInfo.user_info.birthday.substring(0, 4) }}
          </div>
          <div :class="UI.isMobile ? 'margin-top-xs' : 'margin-left'">
            籍贯: {{ playerInfo.user_info.native_place.join() }}
          </div>
          <div :class="UI.isMobile ? 'margin-top-xs' : 'margin-left'">
            注册号: {{ playerInfo.user_id }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="playerPoints.season"
      class="margin-top-lg bg-blue light radius-10 padding-sm"
    >
      <el-dropdown trigger="click" @command="handlePointsSeason">
        <div class="flex align-center points-season-trigger">
          <span class="text-bold text-lg">{{ pointsSeason }}赛季积分</span>
          <i class="el-icon-arrow-down margin-left-xs"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="points-season-menu">
          <el-dropdown-item
            v-for="season in playerPoints.seasons"
            :key="season"
            :command="season"
          >
            <span>{{ season }}赛季</span>
            <i
              v-if="season === pointsSeason"
              class="el-icon-check points-season-check"
            ></i>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="flex flex-wrap margin-top-xs">
        <div
          v-for="(item, index) in playerPoints.items"
          :key="index"
          class="points-item"
        >
          <div>{{ item.item }} · {{ item.group }}</div>
          <div class="text-left">
            <span class="text-bold">{{ item.points }}</span>
          </div>
        </div>
      </div>
      <div v-if="!playerPoints.items.length" class="margin-top-xs">
        该赛季暂无积分
      </div>
    </div>

    <Enrolling></Enrolling>

    <div
      class="flex align-center justify-between margin-top-lg"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>参赛成绩</h1>
      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="赛事年份">
          <el-date-picker
            value-format="yyyy"
            v-model="filterForm.time"
            type="year"
            placeholder="选择年份"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="game_start_time"
        label="赛事时间"
      ></el-table-column>
      <el-table-column prop="title" label="赛事名称"></el-table-column>

      <el-table-column prop="address" label="赛事地点"></el-table-column>
      <el-table-column prop="item" label="参赛项目"></el-table-column>
      <el-table-column prop="group" label="组别"></el-table-column>

      <el-table-column prop="sort" label="名次" sortable width="120">
        <template slot-scope="scope">
          {{
            parseFloat(scope.row.sort).toString() == 'NaN'
              ? scope.row.sort
              : Number(scope.row.sort)
          }}
        </template>
      </el-table-column>
      <el-table-column label="证书" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.evidence_data && scope.row.sort"
            size="mini"
            type="primary"
            @click="showEvidence(scope.row)"
          >
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="isShowEvidence"
      width="840px"
      show-close
      @close="evidenceUrl = ''"
      :fullscreen="UI.isMobile"
      v-if="isShowEvidence"
    >
      <div v-loading="isLoading" v-if="isLoading">请稍后，处理中</div>
      <div
        style="position: relative"
        :style="evidenceUrl ? 'width: 100%' : 'width: 800px'"
        ref="evidence"
      >
        <img v-if="evidenceUrl" :src="evidenceUrl" style="width: 100%;" />
        <div v-else>
          <img :src="evidence.evidencePicture" width="800px" />
          <div
            v-for="(item, index) in evidence.evidenceData"
            :key="index"
            style="position: absolute;"
            :style="
              `top: ${item.top}; left: ${item.left}; font-size:${item.fontSize}; size:${item.size}; text-wrap: nowrap`
            "
          >
            {{ item.text }}
          </div>
        </div>
      </div>
      <!-- <div class="flex justify-center align-center">
        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="exportEvidence()"
        >
          导出
        </el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { getPlayerById, getResultsById, getPointsById } from '@/servers/players.js';
import { checkIdentifierCode } from '@/servers/user.js';
import { startLoading, closeLoading } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import Enrolling from './enrolling.vue';
import html2canvas from 'html2canvas';
import { idCardRegex } from '@/utils/reConsts.js';

export default {
  components: {
    Enrolling,
  },

  computed: {
    ...mapState(['UI', 'User']),
  },

  data() {
    return {
      evidenceUrl: '',
      isLoading: false,
      playerInfo: {},
      tableData: [],
      needShowEvidence: false,
      isShowEvidence: false,
      evidence: {},
      playerPoints: {},
      pointsSeason: '',
      filterForm: {
        page_size: 10,
        page: 1,
      },
      total: 0,
    };
  },

  watch: {
    $route: 'routeChange',
  },

  mounted() {
    this.routeChange();
  },

  methods: {
    getEvidence: function(row) {
      this.evidence = {
        evidencePicture: row.evidence_picture,
        evidenceData: [],
      };
      let evidence_config = row.evidence_config.split(';');
      let evidence_data = row.evidence_data.split(';');

      for (let index in evidence_config) {
        let item_evidence_config = evidence_config[index].split(',');

        this.evidence.evidenceData.push({
          top: item_evidence_config[0] + 'px',
          left: item_evidence_config[1] + 'px',
          fontSize: item_evidence_config[2] + 'px',
          color: item_evidence_config[3],
          text: evidence_data[index],
        });
      }
      this.isShowEvidence = true;
      let that = this;
      this.isLoading = true;
      setTimeout(() => {
        that.exportEvidence();
      }, 1000);
    },

    showEvidence: function(row) {
      let that = this;
      this.$prompt('请输入证件号码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: idCardRegex,
        inputErrorMessage: '格式不正确',
      })
        .then(({ value }) => {
          checkIdentifierCode(
            {
              identifier_code: value.trim(),
              user_id: parseInt(this.$route.query.id),
            },
            function(res) {
              that.getEvidence(row);
            },
          );
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: 'info',
            message: '取消输入',
          });
        });
    },

    exportEvidence: function() {
      const ref = this.$refs.evidence; // 截图区域
      let that = this;
      html2canvas(ref, {
        backgroundColor: '#ffffff',
        useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png');
        that.evidenceUrl = dataURL;
        that.isLoading = false;
        // const creatDom = document.createElement('a');
        // document.body.appendChild(creatDom);
        // creatDom.href = dataURL;
        // creatDom.download = '证书';
        // creatDom.click();
      });
    },

    routeChange: function() {
      let that = this;
      // if (this.$route.query.id == this.User.user.id) {
      //   this.needShowEvidence = true;
      // } else if (
      //   (this.User.user.role =
      //     this.$roleConsts.ORG.value &&
      //     this.$route.query.id.indexOf(this.User.orgUserList) >= 0)
      // ) {
      //   this.needShowEvidence = true;
      // } else {
      //   this.needShowEvidence = false;
      // }

      getPlayerById(this.$route.query.id, function(res) {
        that.playerInfo = res;
        that.flushData();
      });

      this.pointsSeason = '';
      this.flushPoints();
    },

    flushPoints: function() {
      let that = this;
      const params = this.pointsSeason ? { season: this.pointsSeason } : {};
      getPointsById(this.$route.query.id, params, function(res) {
        that.playerPoints = res;
        that.pointsSeason = res.season;
      });
    },

    handlePointsSeason: function(season) {
      this.pointsSeason = season;
      this.flushPoints();
    },

    flushData: function() {
      let that = this;
      this.page = 1;
      getResultsById(0, this.$route.query.id, this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray';
      } else {
        return 'bg-white';
      }
    },
  },
};
</script>

<style scoped>
.points-season-trigger {
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.points-season-trigger:hover {
  background-color: rgba(0, 129, 255, 0.08);
}

.points-item {
  background-color: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(0, 129, 255, 0.15);
  color: #0081ff;
  border-radius: 6px;
  padding: 6px 10px;
  text-align: left;
  white-space: nowrap;
  width: 180px;
  margin-right: 8px;
  margin-bottom: 6px;
}
</style>

<style>
.points-season-menu {
  border-radius: 8px;
}

.points-season-menu .el-dropdown-menu__item {
  color: #0081ff;
  padding: 8px 20px 8px 16px;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.points-season-menu .el-dropdown-menu__item:not(.is-disabled):hover,
.points-season-menu .el-dropdown-menu__item:focus {
  background-color: #cce6ff;
  color: #0081ff;
}

.points-season-check {
  margin-left: 16px;
  color: #0081ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/players/info.vue